import { render, staticRenderFns } from "./AgreeButtons.vue?vue&type=template&id=fca595f6"
import script from "./AgreeButtons.vue?vue&type=script&lang=js"
export * from "./AgreeButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports